import api, { ServerResponse } from "./agritech";

export type QrPairing = {
  id: number;
  client_id: number;
  field_id: number;
  content: string;
  label: string | null;
  created_at: string;
  updated_at: string;
  field?: { id: number; name: string; farm: string | null };
};

export async function listQrCodes(
  token: string,
  clientId: number
): Promise<ServerResponse<QrPairing[]>> {
  const response = await api.get(`${clientId}/qr-codes`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function createQrPairing(
  token: string,
  clientId: number,
  data: { content: string; field_id: number; label?: string }
): Promise<ServerResponse<QrPairing>> {
  const response = await api.post(`${clientId}/qr-codes`, data, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function lookupQrCode(
  token: string,
  clientId: number,
  content: string
): Promise<ServerResponse<QrPairing>> {
  const response = await api.get(
    `${clientId}/qr-codes/lookup?content=${encodeURIComponent(content)}`,
    { headers: { Authorization: `Bearer ${token}` } }
  );
  return response.data;
}

export async function deleteQrPairing(
  token: string,
  clientId: number,
  id: number
): Promise<ServerResponse<null>> {
  const response = await api.delete(`${clientId}/qr-codes/${id}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}
